import { useQuery } from '@apollo/client';
import { isNil } from 'lodash';
import { Queries } from '@shared/api';
import { API } from '@shared/types/api';

export function useEntityBatch(entityBatchId?: string, workflowTemplateId?: string) {
  return useQuery<
    API.GetRecurringEntitiesScheduleQuery,
    API.GetRecurringEntitiesScheduleQueryVariables
  >(Queries.entity.getRecurringEntitiesSchedule, {
    variables: { input: { id: entityBatchId ?? '', workflowTemplateId: workflowTemplateId ?? '' } },
    skip: isNil(entityBatchId) || isNil(workflowTemplateId),
  });
}
